export default "__VITE_ASSET__BeelfZgO__"